<style lang="scss" src="./index.scss"></style>
<template>
  <div
    :class="{
      'wgt-goods-grid': true,
      'padded': value.padded
    }"
  >
    <div class="hm-title-box">
      <div class="title">
        {{value.title}}
      </div>
      <div class="title-btn">
        <div class="title-subtitle">{{value.cta.desc}}</div>
        <div class="icon">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="hm-title-pic">
      <el-row>
        <el-col :span="6" v-for="(item, index) of value.data" :key="index">
          <sp-image :src="item.imgUrl" :circle="0"  />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import config from './config'
export default {
  name: "HmShowcase",
  wgtName: 'HmShowcase',
  wgtDesc: 'hmShowcase',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {}
  },
  computed: {
    leftGoodsList() {
      const { data } = this.value
      const leftFilterGoods = data.filter((item, index) => {
        if (index % 2 == 0) {
          return item
        }
      })
      return leftFilterGoods
    },
    rightGoodsList() {
      const { data } = this.value
      const rightFilterGoods = data.filter((item, index) => {
        if (index % 2 == 1) {
          return item
        }
      })
      return rightFilterGoods
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
